// extracted by mini-css-extract-plugin
export default {"root":"LayoutDefault_root__Krwyp","container":"LayoutDefault_container__LA6Ui"};